import { render, staticRenderFns } from "./softg.vue?vue&type=template&id=db2b4318"
import script from "./softg.vue?vue&type=script&lang=js"
export * from "./softg.vue?vue&type=script&lang=js"
import style0 from "./softg.vue?vue&type=style&index=0&id=db2b4318&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports